export default {
  state: {
    scrollPosition: 0,
    body: document.querySelector('body'),
    slider: {
      type: undefined,
      active: false
    },
    loading: false
  },
  mutations: {
    updateScroll(state, payload) {
      state.scrollPosition = payload
    },
    updateSlider(state, payload) {
      state.slider = payload
    },
    changeLoading(state, payload) {
      state.loading = payload
    }
  },
  actions: {
    updateScroll({ commit }, payload) {
      commit('updateScroll', payload)
    },
    updateSlider({ state, commit }, payload) {
      if (payload.type === state.slider.type) {
        payload.active = !state.slider.active
      }

      if (payload.active) {
        state.body.classList.add('nt-slider-open')
      } else {
        state.body.classList.remove('nt-slider-open')
      }
      commit('updateSlider', payload)
    },
    changeLoading({ commit }, payload) {
      commit('changeLoading', payload)
    }
  },
  getters: {
    scrolling: state => state.scrollPosition < -20,
    scrollY: state => Math.abs(state.scrollPosition),
    slider: state => state.slider,
    loading: state => state.loading
  }
}
